import React from "react";

interface DateOneBoxProps {
  label?: string;
  date?: string;
  onDateChange: (date: string) => void;
  className?: string;
  disabled?: boolean;
  required?: boolean;
}

// 오늘 날짜를 YYYY-MM-DD 형식으로 반환하는 함수
const getTodayFormatted = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

// YYYY-MM-DD를 YYYY/MM/DD로 변환
const formatDateDisplay = (dateStr: string) => {
  if (!dateStr) return "";
  return dateStr.replace(/-/g, "/");
};

export default function DateOneBox({
  label,
  date,
  onDateChange,
  className = "",
  disabled = false,
  required = false,
}: DateOneBoxProps) {
  const hasLabel = label !== undefined;

  // 기본값 설정 (오늘 날짜로 기본값 설정)
  const currentDate = date || getTodayFormatted();

  return (
    <div className={`relative ${className}`}>
      {/* Label - 속성 존재 시에만 영역 생성 */}
      {hasLabel && (
        <div className="h-6 mb-1">
          <label className="block text-base font-normal text-[#414651]">
            {required && <span className="text-red-500 mr-1">*</span>}
            {label}
          </label>
        </div>
      )}

      {/* Date Input Box */}
      <div className="relative">
        <div className="relative">
          <input
            type="date"
            value={currentDate}
            onChange={e => onDateChange(e.target.value)}
            disabled={disabled}
            className={`
              w-full border border-r-0 rounded-l-md pr-7 py-2 rounded-r-md
              focus:outline-none text-transparent
              [&::-webkit-calendar-picker-indicator]:opacity-0
              [&::-webkit-calendar-picker-indicator]:absolute
              [&::-webkit-calendar-picker-indicator]:left-0
              [&::-webkit-calendar-picker-indicator]:top-0
              [&::-webkit-calendar-picker-indicator]:w-full
              [&::-webkit-calendar-picker-indicator]:h-full
              ${
                disabled
                  ? "bg-[#F6F6F6] border-[#CCCCCC] cursor-not-allowed [&::-webkit-calendar-picker-indicator]:cursor-not-allowed"
                  : "bg-white border-[#CCCCCC] cursor-pointer focus:ring-2 focus:ring-[#55b938] focus:border-[#55b938] [&::-webkit-calendar-picker-indicator]:cursor-pointer"
              }
            `}
          />
          {/* 커스텀 날짜 표시 */}
          <div
            className={`absolute left-3 top-1/2 transform -translate-y-1/2 pointer-events-none font-medium ${
              disabled ? "text-[#AAAAAA]" : "text-[#333333]"
            }`}
          >
            {formatDateDisplay(currentDate)}
          </div>
        </div>
        {/* Calendar Icon */}
        <div className="absolute right-0 top-0 bottom-0 bg-[#F6F6F6] rounded-r-md flex items-center justify-center w-10 pointer-events-none border border-[#CCCCCC]">
          <img src={disabled ? "/icons/disableCalendar.svg" : "/icons/calendar.svg"} alt="calendar" />
        </div>
      </div>
    </div>
  );
}
